import React from "react";
import {
  Grid,
  Typography,
  // InputAdornment,
  // IconButton,
} from "@material-ui/core";
// import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import FormikControl from "@Components/FormikControl/FormikControl.js";
import { Button } from "@material-ui/core";
import useStyles from "@Views/Styles/LoginStyles";
import { useAuth } from "@Views/Authentication/AuthContext";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import FGVLogo from "assets/img/fgv-logo.png";
import { getRedirectUrl } from "utils";

const FirstTimePassword = (props) => {
  const classes = useStyles();

  let initialValues = {
    password: "",
    password1: "",
  };

  const {
    login,
    loggedIn,
    authLoading,
    errorMessage,
    logout,
    setErrorMessage,
  } = useAuth();

  const onSubmit = (values) => {
    if (values.password.length && values.password1.length) {
      login(
        props.location.state.employee_id,
        values.password,
        values.password1,
        true
      );
    }
  };

  const validationSchema = Yup.object({
    password: Yup.string().required("New Password"),
    password1: Yup.string().required("Re-enter New Password"),
  });

  // const handleClickShowPassword = () => {
  //   setShowPassword(!showPassword);
  // };

  if (loggedIn) {
    let redirectUrl = getRedirectUrl();
    if (redirectUrl)
      return (
        <Redirect to={{ pathname: redirectUrl, state: { login: true } }} />
      );
    setErrorMessage("User doesn't have any module/s assigned.");
    // logout();
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {!authLoading ? (
        (formik) => {
          return (
            <Form style={{ width: "100%" }}>
              <Grid
                className={classes.root}
                container
                spacing={2}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={10} sm={6} lg={3}>
                  <img src={FGVLogo} alt="FGV" width={200} />
                </Grid>
                <Grid item xs={10} sm={6} lg={3}>
                  <Typography variant="h4">Set Password</Typography>
                </Grid>

                <Grid className={classes.grid} item xs={10} sm={6} lg={3}>
                  <FormikControl
                    control="restricted"
                    regex={/[^ ]/i}
                    variant="outlined"
                    label={
                      formik.touched.password && formik.errors.password
                        ? formik.errors.password
                        : "New Password"
                    }
                    labelClasses={classes.labelStyles}
                    name="password"
                    // type={showPassword ? "text" : "password"}
                    fullWidth
                    password
                    size="small"
                    // InputProps={{
                    //   endAdornment: (
                    //     <InputAdornment position="end">
                    //       <IconButton
                    //         aria-label="Toggle password visibility"
                    //         onClick={handleClickShowPassword}
                    //       >
                    //         {showPassword ? <VisibilityOff /> : <Visibility />}
                    //       </IconButton>
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                  <FormikControl
                    control="restricted"
                    regex={/[^ ]/i}
                    labelClasses={classes.labelStyles}
                    variant="outlined"
                    label={
                      formik.touched.password1 && formik.errors.password1
                        ? formik.errors.password1
                        : "Re-Enter New Password"
                    }
                    name="password1"
                    password
                    // type={showPassword ? "text" : "password"}
                    fullWidth
                    size="small"
                    // InputProps={{
                    //   endAdornment: (
                    //     <InputAdornment position="end">
                    //       <IconButton
                    //         aria-label="Toggle password visibility"
                    //         onClick={handleClickShowPassword}
                    //       >
                    //         {showPassword ? <VisibilityOff /> : <Visibility />}
                    //       </IconButton>
                    //     </InputAdornment>
                    //   ),
                    // }}
                  />
                  <Grid item>
                    <Typography
                      align="center"
                      variant="subtitle1"
                      color="error"
                    >
                      {errorMessage.length ? errorMessage : errorMessage}
                    </Typography>
                  </Grid>

                  <Button
                    type="submit"
                    disabled={!formik.isValid || authLoading}
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{
                      marginTop: 10,
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }
      ) : (
        <LoadingIcon image text="Logging in" />
      )}
    </Formik>
  );
};

FirstTimePassword.propTypes = {
  location: PropTypes.object,
};
export default FirstTimePassword;
